var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"12","width":"12"}},[_c('circle',{attrs:{"cx":"6","cy":"6","r":"6","fill":_vm.fillColor}})])}
var staticRenderFns = []

export { render, staticRenderFns }